import { render } from "./VoipRegistry.vue?vue&type=template&id=6d3ce662"
import script from "./VoipRegistry.vue?vue&type=script&lang=js"
export * from "./VoipRegistry.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "6d3ce662"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d3ce662', script)) {
    api.reload('6d3ce662', script)
  }
  
  module.hot.accept("./VoipRegistry.vue?vue&type=template&id=6d3ce662", () => {
    api.rerender('6d3ce662', render)
  })

}

script.__file = "src/views/services/modules/voip/pills/VoipRegistry.vue"

export default script